import { type OnChangeFn, type SortingState, getCoreRowModel } from "@tanstack/react-table"
import type { FC, RefObject } from "react"
import type { CombinedError } from "urql"

import { useProductInventoryLotColumns } from "../../hooks"

import { AerosBaseTable } from "@/components/Tables/Aeros/components/AerosBaseTable"
import type { InventoryByLotItem, Product } from "@/graphql/codegen/graphql"

interface ProductInventoryLotsTableProps {
  product: Product
  data: InventoryByLotItem[]
  loading?: boolean
  error?: CombinedError | Error
  sorting: SortingState
  containerRef?: RefObject<HTMLDivElement>
  canMaintain: boolean
  onSortingChange: OnChangeFn<SortingState>
  onTransfer?: (inventory: InventoryByLotItem) => void
  onCoaView?: (inventory: InventoryByLotItem) => void
  onScroll?: () => void
}

export const ProductInventoryLotsTable: FC<ProductInventoryLotsTableProps> = ({
  product,
  data,
  error,
  loading = false,
  sorting,
  containerRef,
  canMaintain,
  onSortingChange,
  onTransfer,
  onCoaView,
  onScroll,
}) => {
  const columns = useProductInventoryLotColumns({ product, canMaintain, onTransfer, onCoaView })

  return (
    <AerosBaseTable
      error={error}
      features={{
        table: {
          stickyHeader: true,
        },
        tanstackOptions: {
          data,
          columns,
          state: {
            sorting,
            isLoading: loading,
          },
          manualSorting: true,
          enableSorting: true,
          enableMultiSort: false,
          enableSortingRemoval: false,
          getCoreRowModel: getCoreRowModel(),
          onSortingChange,
        },
      }}
      slotProps={{
        container: { ref: containerRef, onScroll },
      }}
      noDataMessage='No lot inventory records found'
    />
  )
}
